var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchweisstechnikLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1290 1270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient10);\n      }\n\n      .st2 {\n        fill: #505253;\n      }\n\n      .st3 {\n        fill: url(#linear-gradient21);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st5 {\n        fill: #323234;\n      }\n\n      .st6 {\n        fill: url(#linear-gradient9);\n      }\n\n      .st7 {\n        fill: url(#linear-gradient18);\n      }\n\n      .st8 {\n        fill: url(#linear-gradient23);\n      }\n\n      .st9 {\n        fill: url(#linear-gradient8);\n      }\n\n      .st10 {\n        fill: url(#linear-gradient11);\n      }\n\n      .st11 {\n        fill: url(#linear-gradient16);\n      }\n\n      .st12 {\n        fill: url(#linear-gradient22);\n      }\n\n      .st13 {\n        fill: url(#linear-gradient19);\n      }\n\n      .st14 {\n        fill: url(#linear-gradient12);\n      }\n\n      .st15 {\n        fill: #535556;\n      }\n\n      .st16 {\n        fill: url(#linear-gradient7);\n      }\n\n      .st17 {\n        fill: #144c89;\n      }\n\n      .st18 {\n        fill: url(#linear-gradient20);\n      }\n\n      .st19 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st20 {\n        fill: url(#linear-gradient14);\n      }\n\n      .st21 {\n        fill: url(#linear-gradient5);\n      }\n\n      .st22 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st23 {\n        fill: url(#linear-gradient15);\n      }\n\n      .st24 {\n        fill: url(#linear-gradient17);\n      }\n\n      .st25 {\n        fill: url(#linear-gradient6);\n      }\n\n      .st26 {\n        fill: url(#linear-gradient13);\n      }\n\n      .st27 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 328.46,
    y1: 457.75,
    x2: 612.79,
    y2: 461.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#323234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#535556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 816.72,
    y1: 296.17,
    x2: 937.1,
    y2: 296.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 382.15,
    y1: 705.34,
    x2: 382.15,
    y2: 792.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 586.89,
    y1: 705.34,
    x2: 586.89,
    y2: 792.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 671.62,
    y1: 705.34,
    x2: 671.62,
    y2: 792.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: 110.45,
    y1: 705.34,
    x2: 110.45,
    y2: 792.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient6",
    x1: 828.28,
    y1: 705.34,
    x2: 828.28,
    y2: 792.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient7",
    x1: 479.16,
    y1: 705.34,
    x2: 479.16,
    y2: 792.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient8",
    x1: 1075.01,
    y1: 705.34,
    x2: 1075.01,
    y2: 792.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient9",
    x1: 907.04,
    y1: 705.34,
    x2: 907.04,
    y2: 792.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient10",
    x1: 194.68,
    y1: 705.34,
    x2: 194.68,
    y2: 792.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient11",
    x1: 1186.06,
    y1: 705.34,
    x2: 1186.06,
    y2: 792.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient12",
    x1: 733.11,
    y1: 322.9,
    x2: 815.06,
    y2: 322.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient13",
    x1: 752.39,
    y1: 705.34,
    x2: 752.39,
    y2: 792.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient14",
    x1: 999.92,
    y1: 705.34,
    x2: 999.92,
    y2: 792.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient15",
    x1: 287.42,
    y1: 705.34,
    x2: 287.42,
    y2: 792.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient16",
    x1: 706.86,
    y1: 398.02,
    x2: 747.39,
    y2: 398.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient17",
    x1: 1132.27,
    y1: 705.34,
    x2: 1132.27,
    y2: 792.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient18",
    x1: 251.83,
    y1: 705.34,
    x2: 251.83,
    y2: 792.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient19",
    x1: 964.18,
    y1: 705.34,
    x2: 964.18,
    y2: 792.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient20",
    x1: 530.44,
    y1: 705.34,
    x2: 530.44,
    y2: 792.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient21",
    x1: 719.23,
    y1: 365.99,
    x2: 756.14,
    y2: 365.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient22",
    x1: -362.59,
    y1: -166.22,
    x2: -155.31,
    y2: -166.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient23",
    x1: 127.75,
    y1: -127.7,
    x2: 335.04,
    y2: -127.7,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M619.53,546.22l-32.18-9.48c-4.53-1.33-8.38-4.18-13.63-3.38l24.59,10.25c4,1.67,7.95,4.17,11.77,6.05l11.75,5.79c1.78,2.33-12.81,3.36-12.71,3.36l-21.39.8c-2.06.08-3.75-.05-4.87.79l8.36,1.2,22.22,3.87,11.82,2.06c-5.92,3.02-10.83,4.45-16.54,6.33s-10.92,3.87-16.64,5.44l-45.27,12.4c10.11-.91,19.26-2.73,29.13-4.2l19.86-2.95,18.51-3.28c5.18-.92,9.32-2.11,15.09-2.13l-10.48,7.91c-9.36,7.07-15.59,9.85-25.33,17.68,7.72-2.8,14.28-7.02,21.79-10.39l10.29-4.61c-.28,3.63-2.05,5.41-4.04,7.82l-11.31,13.76-12.08,14.1-7.52,9.29c-3.23,3.99-6.86,6.88-10.83,10.44,1.46-3.03,3.53-5.11,5.69-7.52l8.54-9.5c2.32-2.58,3.88-4.77,6.27-8.29l-25.65,1.57-13.9.53-198.82-.26,66.73-74.73,107.18.02c9.89-.83,18.14-4.34,25.36-10.69,9.36-8.02,26.67-30.42,23.26-43.1-.75-2.8-4.57-4.75-7.64-4.76l-98.87-.28c-20.86-.06-40.43-6.34-57.75-17.37-26.07-16.61-41.85-44.57-42.59-75.83-.83-34.99,15.8-67.66,43.59-88.64,21.64-16.33,47.48-24.65,74.8-24.64l239.7.05,31.06-.2c5.91-.04,9.44-1.3,17.4-1.97-9.73,3.1-18.41,6.11-26.31,11.51-16.55,11.29-28.12,27.04-33.23,46.46l-8.53,1.75-6.16,15.25-35.56.27-184.42.23c-14.47.02-27.21,9.86-31.87,22.55s-.19,25.19,11.12,30.97c3.55,1.81,8.46,3.51,12.84,3.51l168.53.1c12.63,0,31.96,3.38,42.02,11.13l9.32,7.17c.73,2.28-1.98,6.2-3.12,8.37-5.24,9.93-6.63,20.55-8.74,31.39-1.91,9.82-6.63,18.63-10.09,27.92l-5.14,13.83c-.27.73-1.95,1.98-2.61,2l.89-15.92.63-13.24-9.4,28.93c-1.85-7.75-2.36-13.73-2.68-20.73l-.95-20.99c-.09-1.95-.83-4.75-1.63-7.1l-.08,42.21c0,2.37-.69,5.31-1.32,7.04-1.74-6.98-3.2-12.53-5.27-18.63l-3.32-9.76,3.26,32.82c-4.29-1.82-4.85-5.59-6.12-9.19l-13.76-39.01c-.48-1.35-1.78-3.48-2.64-4.47l9.76,33.67c2.48,8.56,4.57,16.4,6.53,25.71-4.97-4.71-7.12-9.75-10.99-14.4l-9.09-10.91,7.26,19.84c1,2.74,1.5,6.31,2.07,9.41l-6.74-5.95-27.64-28.18c10.43,15.36,22.26,26.81,33.27,43.47l-13.37-6.26c-3.79-1.78-8.1-3.33-11.79-5.29l-8.82-4.7c2.1,2.05,3.82,3.48,5.99,5.38l12.74,11.12c2.94,2.57,5.13,4.83,7.63,7.87-2.95.28-4.87.22-7.17-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M743.06,573.92c-1.5-.04-28.4-3.65-31.56-4.33l-18.72-4.03c7.33-3.38,19.56-6.32,26.75-8.05.3-.22,1.2-1.12,1.54-1.44-4.6.18-8.79.88-12.99.64l-11.22-.64c-.99-.06-3.03-.6-4.29-1.02l14.7-8.85c4.71-2.84,9.37-4.85,14.01-8.19-8.01,1.43-19.73,9.58-27.34,8.98,3.72-6.02,15.38-12.64,18.85-17.7l-18.17,9.72c-1.59-3.71.56-5.47,2.49-7.95l7.82-10.03c4.77-6.12,10.11-11.22,14.07-18.38l-23.46,22.91c-1.78,1.74-3.14,2.97-5.23,4.67-.39-3.2-.24-5.53.84-7.74l7.96-16.33c1.35-2.77,2.95-4.96,3.42-8.38l-16,22.75c-1.36,1.93-2.84,3.55-4.75,5.55l4.65-13.58c2.47-7.2,6.02-13.63,9.15-20.6l4.7-10.43c2.54-5.63,5.41-10.7,7.86-16.29l7.34-16.73,4.27-9.84c3.03-2.1,11.41,3.89,15.67-5.07l9.21-19.4,20.4-2.09,116.1.06-25.58,64.4h-34.64s-26.54.33-26.54.33l-23.41-.06c-12.13-.03-22.54,7.1-25.13,19.15-2.29,10.65,4.93,20.84,16.07,21.15l14.85.42c11.41.32,16.46-.65,29.97-.03,2.65.12,5.04.17,7.64.04,7.05-.35,13.96-.26,21.05-.07,11.12.31,21.79.74,32.39,4.61,24.91,9.1,41.54,31.27,43.82,57.56.64,7.4.97,14.46-.07,21.9-3.75,26.82-18.64,50.46-42.69,63.58-12.18,6.64-25.67,11.28-40.07,11.28l-270.44.05,21.54-22.32,11.79-12.12,18.3-18.91c1.55-1.6,4.1-4.84,5.71-6.22.79-.66,3.6.52,4.84,1.18l-6.67,11.17-1.7,2.62c-.47.72.93,2.31,1.62,3.21l5.36-8.86c2.12-3.51,5.04-6.88,9.04-9.14l197.6-.15c11.58,0,20.32-8.65,23.27-18.52,2.16-7.21-.34-14.74-5.9-19.34-4.99-4.12-11.03-4.19-17.26-4.2l-51.49-.08-31.38-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M933.28,317l-111.08-.04c-1.6,0-5.37-2.36-5.38-4.04l-.03-15.85-.07-17.31c0-1.83,3.16-3.97,5.39-4.41h110.25c2.44.01,4.75,2.45,4.74,4.55l-.02,33.37c0,1.22-1.86,2.94-3.8,3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M329.99,878.77c-1.58,9.47-10.44,17.14-20.03,17.16l-57.52.13.05-14.63,55.53-.13c4.14,0,7.24-3.21,7.69-6.92.39-3.21-2.81-7.87-7.18-7.92l-39.49-.54c-11.67-.16-20.01-10.71-19.8-21.36s8.38-21.16,20.03-21.2l57.39-.18.2,14.76-55.84.06c-3.66,0-6.27,3.51-6.52,6.64s2.63,6.9,6.68,6.91l36.82.08c6.78.01,12.84,3.07,16.8,7.28,4.92,5.23,6.52,11.77,5.17,19.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M728.48,895.86l-57.57.25-.02-14.66,56.13-.16c4.43-.01,7.26-3.83,7.2-7.77-.05-2.96-3.08-7.17-7.28-7.2l-38.05-.22c-11.57-.07-20.6-9.67-20.9-20.64-.29-10.49,7.65-21.86,19.46-21.95l57.64-.42.16,14.77-56.08.21c-3.67.01-6.08,4.67-5.87,7.3.25,3.21,2.98,6.34,6.86,6.32l34.78-.11c12.51-.04,22.9,7.62,24.13,20.02,1.15,11.57-7.04,24.19-20.61,24.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M424.38,731.31l16.39.32-34.68,63.23c-1.67,3.05-4.52,4.38-8.13,4.26-2.46-.08-5.65-1.36-6.66-3.29l-9.28-17.72-11.24,19.04c-1.65,2.8-9.7,2.51-12.08.14l-35.16-65.72,16.25-.25,25.26,47.23,8.83-15.35-17.01-31.96,16.59.1,25.08,47.09,13.22-23.42,12.61-23.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "511.98 866.13 499.01 866.24 475.3 866.42 475.04 881.3 528.87 881.38 528.98 896.05 460.17 896.11 460.13 823.13 528.82 823.12 529 837.95 475.18 837.99 475.16 851.87 511.8 851.93 511.98 866.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M605.19,798.57l-53.37.36.05-13.91,53.02-.13c3.15,0,6.11-4.07,6.22-6.41.13-2.81-2.6-7.23-6.22-7.26l-36.83-.3c-7.66-.06-14.27-5.19-17.01-10.8-3.46-7.07-2.92-15.06,1.88-21.29,3.32-4.3,9.55-7.59,15.26-7.6l52.99-.11-.08,13.74-52.18.08c-3.03,0-5.71,4.17-5.52,6.41.27,3.19,3.04,5.79,6.51,5.8,12.16.02,23.77-.31,35.61.3,11.12.57,19.31,9.92,19.46,20.12s-7.93,20.91-19.77,20.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M690.97,798.35c-18.79.91-36.62.41-54.91.35v-13.67s53.88-.14,53.88-.14c3.02,0,5.89-4.24,5.99-6.48.12-2.7-2.72-7.02-6.37-7.08l-38.26-.63c-12.17-.2-19.47-12.19-17.37-23.72,1.48-8.1,8.59-15.39,17.58-15.44l54.17-.34v13.67s-51.79.08-51.79.08c-2.96,0-5.56,3.24-5.84,5.65s1.72,6.36,4.91,6.39l35.37.34c11.39.11,20.56,8.32,21.27,19.37.64,9.99-6.67,21.09-18.65,21.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M146.65,786.37c-3.19,7.42-10.83,12.38-18.69,12.4l-52.79.11-.14-13.86,52.98-.07c3.69,0,6.46-3.42,6.68-6.54.17-2.45-2.54-7.08-6.14-7.12l-37.53-.35c-5.98-.06-11.5-4.01-14.32-7.45-4.47-5.47-5.04-11.88-3.3-18.57,1.93-7.39,9.84-13.46,18.08-13.5l53.39-.27-.21,13.69-51.76.07c-3.09,0-5.58,3.09-5.98,5.76-.36,2.4,1.99,6.34,5.01,6.36l36.06.25c7.49.05,14.97,4.93,18.3,11.42,2.67,5.21,2.87,11.87.37,17.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "845.11 771.35 811.29 771.57 811.16 784.94 859.42 785.07 859.19 798.85 797.14 798.86 797.08 731.28 859.39 731.15 859.49 744.85 811.32 744.94 811.15 757.92 844.98 757.96 845.11 771.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "495.96 771.51 462.47 771.54 462.67 784.97 510.1 785 509.99 798.75 448.33 798.83 448.25 778.9 448.19 731.2 510.04 731.14 510.13 744.88 462.52 744.92 462.51 757.89 495.94 758 495.96 771.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1104.06,798.99l-6.55-.43-23.64-24.38-19.51-19.77-.4,44.18-13.86.05-.04-61.64c0-3.68,3.42-5.98,6.93-5.96,1.94.01,5.24.38,6.35,1.53l42.39,43.84.3-45.31,13.86.25.09,61.65c0,3.21-2.67,6.21-5.92,5.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M939.95,881.67l-38.59-.27-7.3,14.5h-16.7s34.6-68.8,34.6-68.8c3.27-6.5,14.86-4.26,16.37-1.27l35.33,69.94-16.63.42-7.07-14.52ZM932.5,867.36l-11.94-23.6-12.19,23.77,24.13-.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "848.69 895.6 828.25 895.95 801.17 870.85 793.57 864 793.38 895.89 778.53 896.09 778.52 823.45 793.44 823.29 793.47 855.53 827.19 823.09 848.52 823.27 809.87 859.49 848.69 895.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M901.38,784.69l42.48.35-.16,13.75-39.73.09c-20.58.05-35.54-17.01-33.58-37.36,1.53-15.88,13.13-29.97,29.92-30.07l43.33-.25v13.61s-40.67.18-40.67.18c-8.71.04-15.42,5.97-17.94,14.16-3.36,10.94,3.51,25.42,16.35,25.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.4,784.84l41.67.19c.25,4.67.22,9-.01,13.79l-39.13.11c-14.26.04-26.51-7.88-31.69-21.39-2.36-6.16-2.86-13.05-1.56-19.84,2.69-13.98,14.02-26.03,28.81-26.16l43.63-.41.27,13.67-42.38.44c-10.95.11-17.92,11.45-16.92,21.76.87,8.93,7.42,17.79,17.31,17.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1182.87,764.52l36.17,33.7c-6.74.82-12.6.77-18.83.55l-30.63-28.27c-.26-.24-1.16-1.04-1.14-1.05.02-.01-.61.57-.89.82l-.37,28.49-14.04-.1-.05-67c4.67-.54,9.6-.56,14.36-.28l-.23,17.67c-.05,3.69.19,7.33.5,11.17l31.28-29.13,19.64.44-35.79,32.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M758.37,340.7l-7.31,18.31-17.95-7.07c3.06-8.07,5.62-15.6,9.36-23.2,13.51-27.48,41.59-44.22,72.54-41.68l.04,19.13c-24.85-1.73-47.4,11.28-56.69,34.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M401.96,895.53c-4.68.57-9.59.57-14.9.42v-57.96s-28.18-.05-28.18-.05l-.11-14.8,71.09-.03.35,14.84-28.28.07.04,57.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M642.06,823.72l-33.87,41.07-.09,31.23-14.98.03-.03-30.49c-3.1-4.61-7.57-9.77-11.27-14.32l-22.53-27.69,17.7-.47,23.69,28.57,23.48-28.48c6.01-.1,10.8-.12,17.9.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1057.74,881.37c.34,5.25.33,9.95-.02,14.76l-64.77-.11.08-72.73h14.99s0,57.97,0,57.97l49.72.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "759.13 798.6 745.58 798.9 745.44 782.04 745.29 745.14 719.27 744.69 719.39 731.18 785.3 731.14 785.51 744.73 759.24 745.1 759.13 798.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1011.84,771.89l-37.96-.25-.06-13.55,38.02-.09.09-26.87,14.05.23.05,66.91c-4.55.7-8.72.65-14.09.3l-.1-26.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M299.38,771.86l-38.02-.31.18-13.4,37.52-.17.11-26.39c4.69-.36,9.33-.43,14.27-.16l.02,67.12-14.31.15.22-26.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M725.27,424.66c-.97,1.07-4.97-.19-6.27-.75l-11.73-5.1c-.09-3.87-.91-9.16.04-12.55,3.46-12.39,8.23-23.05,13.02-35.29,2.31.43,4.58,1.11,6.68,1.96l20.39,8.24-13.46,32.94c-1.28,3.13-6.28,7.93-8.66,10.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1139.43,798.72l-14.23.11-.09-67.12c4.62-.48,8.9-.57,14.21-.49l.12,67.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M258.97,732.81l-.03,65.7-14.16.19-.08-67.23,11.15-.47c.68-.03,3.12,1.17,3.12,1.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "971.23 798.74 957.04 798.69 956.99 731.61 971.37 731.21 971.23 798.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M537.45,798.72l-13.74.08-.28-54.58c-.02-4.42.1-8.43.34-12.98l13.64-.04.04,67.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M216.04,866.12l-91.01.13-44.81-.28c-1.28,0-1.65-5.24-.02-5.26l46.86-.66,88.71.18c1.31,0,1.24,4.41.27,5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1218.02,860.62c1.9.02,1.68,4.57.04,5.36l-131.76.08c-1.46-.82-1.59-5.72-.1-5.72l96.31-.04,35.5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M750.29,380.4l-13.46-5.1-17.59-7.09,3.84-11.28c.56-1.66,2.32-4.16,4.11-5.35l25.82,9.54c1.93.71,3.71,3.4,2.96,5.25l-5.67,14.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M633.92,935.69l.03,28.86c-2.5,2.59-4.82-.48-6.06-2.46-4.2-6.71-8.05-12.54-12.94-19.53l-.07,22.05-2.45,1.12c-.7.32-1.83-1.78-1.82-2.71l.24-28.68c4.68-.33,5.02,2.17,6.48,4.44l12.12,18.88.64-20.71.06-2.16c.01-.47,3.77.24,3.77.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M820.57,949.6c2.27,2.2,4.16,5.06,4.04,7.92s-2.32,7.34-5.61,7.6c-5.63.44-10.56.41-16.2.28v-30.66c7.24.02,19.6-2.93,21.19,6.03.54,3.03-1.05,6.45-3.43,8.82ZM818.1,947.01c1.5-.39,2.5-4.45,1.87-5.84s-3.25-3.59-4.9-3.58l-8.41.05.53,10.25c3.57.07,6.84.16,10.9-.88ZM816.1,961.93c2.16-.07,4.56-3.29,4.48-5.33-.26-6.6-9.16-5.6-14.03-5.27v10.92s9.55-.32,9.55-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M894.56,963.59c0,1.82-3.61,2.38-4.29,1.31l-13.93-21.8c-.58,1.88-.97,3.71-.98,6.01l-.06,14.71c0,.67-1.36,1.74-1.81,1.85s-1.73-1.3-1.74-2l-.36-25.58c-.01-.85.68-2.73,1.03-3.36.47-.85,3.23.49,3.75,1.31l9.39,14.54c1.55,2.39,3,4.24,4.71,6.15l.36-19.53c.01-.72.58-2.21.8-2.7.34-.74,3.11.89,3.11,1.92l.02,27.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M368.67,963.97l-5.64-12.15-7.33-.05.2,12.8c.01.93-4.03.99-4.03-.19l-.07-29.68,14.26-.03c4.28,0,7.1,4.37,7.2,7.79.12,3.96-1.88,7.34-6,9.15l5.84,13.22c-.81.85-3.88.33-4.43-.85ZM365.02,948.32c1.72-.03,4.31-3.2,4.45-4.91s-1.93-5.47-3.77-5.61c-3.18-.24-6.78-.34-10.02-.41l.47,11.09,8.87-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M577.2,965.64c-5.39-.7-9.3-4.43-9.37-9.73l-.16-10.97c-.09-5.96,4.73-10.5,9.92-10.94s11.31,2.51,12.05,8.57c.53,4.38.52,9.43.08,13.78-.65,6.47-6.07,10.13-12.52,9.29ZM585.8,956.99l.07-12.07c.03-4.24-2.72-7.18-6.51-7.55s-7.19,2.27-7.34,6.65c-.15,4.69-.12,9.09.39,13.98.28,2.67,4.71,4.82,6.85,4.56,2.53-.3,6.51-2.72,6.53-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M938.32,956.84c.01,2.68-3,7.68-5.47,8.03-5.66.8-10.47.77-16.05.55l.02-30.78c6.85-.59,21.36-1.77,21.42,8.25l.08,13.95ZM934.35,956.57l.06-11.41c0-1.85-1.25-5.92-2.89-6.63-2.9-1.25-8.4-1.18-10.91-.7.14,5.87.08,10.18.03,15.38l-.09,8.84,9.65-.2c1.65-.03,4.15-3.46,4.16-5.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M777.15,963.31l-5.36-11.24c-2.07-.4-5.28-.33-7.54.07l-.09,11.86c0,.87-3.19,1.88-3.4,1.11s-.26-1.81-.26-3.24l-.03-27.33,13.57-.09c4.74-.03,7.34,3.96,7.8,8.14s-2,7.26-6.5,9.27l6.62,12.65-2.49,1.14c-.63.29-1.9-1.46-2.32-2.34ZM775.91,947.24c1.28-.46,2.33-4.21,1.98-5.47-1.7-6.09-8.29-4.09-13.59-3.94l.1,10.48c4.12.19,7.59.32,11.51-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1173.8,948.54l-54.77.7-15.16.82-51.51.51c-1.18.01-2.82-1.33-3.16-2.03s1.77-1.92,2.67-1.91l53.17.35,13.96.81,54.79.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M410.89,959.48h-12.67s-1.76,3.64-1.76,3.64l-1,2.09c-.32.67-2.83-.13-3.67-.64l9.84-28.31c.31-.89,2.29-2.38,3.06-2.29s2.07,1.46,2.4,2.42l9.76,28.45c-.43.27-3.46.7-3.77-.06l-2.18-5.3ZM409.8,955.83l-5.34-16.06-5.53,16.17,10.87-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M514.21,965.45c-2.63.44-6.16-.05-8.86-.68-3.03-.71-7.1-4.97-4.14-8.1.98-1.04,3.37,2.07,4.06,3.33,2.1,3.86,8.55,3.04,11.34.69.88-.74,1.53-3.75,1.09-4.77s-2.08-2.47-3.18-2.87l-9.3-3.31c-2.5-.89-4.88-4.91-4.83-7.17.08-3.56,2.24-6.57,5.66-7.84,5.36-1.99,12.04-.22,14.51,4.78.33.66,0,2.65-.44,3.18-2.01,2.4-2.28-5.93-10.17-5.44-2.16.14-4.49,1.88-5.17,3.77s1.05,5.16,3.01,5.76l6.98,2.13c4.02,1.23,6.69,3.82,6.75,7.6.07,4.07-1.64,8-7.31,8.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M225.59,950.06l-16.64-.79-63-.78,63.01-.73,16.3-.82,41.38-.28c.68,0,2.6,1.42,2.31,1.89-.45.71-2,1.94-3.16,1.93l-40.19-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M314.31,952.7l.03,10.12c0,.73-.54,2.05-.76,2.56s-2.75-.6-2.75-1.05l-.37-29.48c5.76-.54,10.44-.6,15.48.05s6.6,6.71,6.04,10.26c-1.47,9.39-10.94,6.78-17.67,7.55ZM325.95,948.8c2.29-3.7,3.31-8.31-.59-10.3-2.84-1.45-7.78-1.07-10.93-.7l-.07,11.27,11.59-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M734.15,951.2l-10.6.54.04,10.49,14-.21c.5,0,1.94.64,2.3.72.57.12-.48,2.8-1.23,2.79l-19.27-.11-.03-31.03c7.66.13,12.95-.14,20.67,0l-.07,2.9-16.46.69-.04,9.73,8.57.29,2.36.08c.67.02.52,3.09-.23,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M974.65,951.2l-10.6.54.04,10.49,14-.21c.5,0,1.94.64,2.3.72.57.12-.48,2.8-1.23,2.79l-19.27-.11-.03-31.03c7.66.13,12.95-.14,20.67,0l-.07,2.9-16.46.69-.04,9.73,8.57.29,2.36.08c.67.02.52,3.09-.23,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M695.29,936.92l1.1-2.28c.33-.69,3.12.78,2.79,1.84l-8.36,26.79c-.28.9-1.61,2.33-2.33,2.5-.96.22-2.98-1.31-3.32-2.4l-8.58-27.4c-.3-.96,3.36-1.89,3.67-.95l7.8,23.53,7.23-21.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M963.58,951.68l.02,10.91,14.32-.18c.68,0,1.93.91,2.21,1.46s-1.46,1.25-2.22,1.27l-15.07.42c-1.19.03-3.45-1.18-3.45-2.38l.12-28.72c7.81.12,13.77.12,21.52,1.58l-17.53,1.83.11,9.99,10.54.20c.88.02,1.06,3.2.13,3.23l-10.68.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M454.77,964.08c-3.46,1.23-17.9,2.27-20.08.47-.57-.47-.03-2.64.44-3.38l14.73-23-16.06-.74.2-1.75c2.58-.98,19.87-2.09,20.38-.28.21.74-.08,2.79-.6,3.61l-14.63,22.92,15.63-.08v2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M997.08,935.83v2.13s6.4-.38,9.43-.02l.09,27.77h3.94l.04-27.6,10.31-.15.12-2.13h-23.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M546.27,963.64c0,.86-2.26,2.43-2.72,1.93s-1.52-2.01-1.52-2.87l.14-15.29.07-11.19c0-.57.85-1.65,1.23-1.9.59-.38,2.64.93,2.64,1.9l.14,27.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M479.23,963.57c0,.96-2.18,2.3-2.6,1.85s-1.52-1.75-1.51-2.6l.34-24.56.05-2.96c.01-.83,3.58-.62,3.59.28l.13,27.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M849.29,964.09c0,.52-1.47,1.9-1.93,1.68-.7-.33-1.98-1.93-1.98-2.92v-25.86c0-.97,1.16-3.25,1.96-3.03s1.88,1.84,1.88,2.95l.07,27.18Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchweisstechnikLogo);
export default __webpack_public_path__ + "static/media/schweisstechnik-logo.4173653562096d2901c325831f2690fa.svg";
export { ForwardRef as ReactComponent };